import React from 'react';
import SimpleTracker from './SimpleTracker';
import { nextMaintenanceNumber } from './services/applicationCounterService';

const MAINTENANCE_TYPES = [
  'Equipment Repair', 'Preventive Maintenance', 'Facility',
  'IT/Network', 'Cleaning', 'Calibration', 'Inspection', 'Other'
];

const MAINTENANCE_PRIORITY = ['Low', 'Medium', 'High', 'Urgent'];

const config = {
  collectionName: 'maintenanceRequests',
  breadcrumbLabel: 'Maintenance Requests',
  breadcrumbIcon: '🔧',
  pageTitle: 'Maintenance Requests',
  entityNoun: 'Maintenance Request',
  entityNounPlural: 'Maintenance Requests',
  numberPrefix: 'MR',
  statusOptions: ['Open', 'Assigned', 'In Progress', 'Completed', 'Closed', 'Cancelled'],
  statusColors: {
    'Open': '#dc2626',
    'Assigned': '#f59e0b',
    'In Progress': '#3b82f6',
    'Completed': '#16a34a',
    'Closed': '#6b7280',
    'Cancelled': '#9ca3af'
  },
  extraFields: [
    {
      key: 'maintenanceType',
      label: 'Type',
      type: 'select',
      options: MAINTENANCE_TYPES
    },
    {
      key: 'priority',
      label: 'Priority',
      type: 'select',
      options: MAINTENANCE_PRIORITY,
      defaultValue: 'Medium'
    },
    {
      key: 'equipmentId',
      label: 'Equipment ID / Asset Tag',
      type: 'text'
    },
    {
      key: 'location',
      label: 'Location',
      type: 'text',
      fullWidth: true
    },
    {
      key: 'assignedTo',
      label: 'Assigned To',
      type: 'text'
    },
    {
      key: 'requestedCompletion',
      label: 'Requested Completion',
      type: 'date'
    }
  ],
  nextNumberFn: nextMaintenanceNumber
};

function MaintenanceRequestsApp() {
  return <SimpleTracker config={config} />;
}

export default MaintenanceRequestsApp;
